import React, { useContext, useState, useEffect } from "react";
import _ from "lodash";
import useMediaQuery from "@mui/material/useMediaQuery";

import { Dlog } from "./../../../../utils/Dlog";

import HttpContext from "../../../../contexts/HTTP/HttpContext";
import KioskContext from "../../../../contexts/Kiosk/KioskContext";
import SocketIOContext from "../../../../contexts/Kiosk/SocketProvider/SocketIOContext";

import { useNavigate } from "react-router-dom";

import { Translate, Localize, translate } from "react-i18nify";
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import { setTranslations, setLocale } from "react-i18nify";
import QRCode from "react-qr-code";

import { IdleTimerContext, IdleTimerProvider } from "react-idle-timer";

import IdleTimerDisplay from "./../Shared/IdleTimerDisplay_V";
import LanguageButtons from "./../Shared/LanguageButtons";
import PhoneKeypad from "./../CustomerPhoneNumber/PhoneKeypad";
import PhoneConfirm from "./../CustomerPhoneNumber/PhoneConfirm";
import PhoneDisplay from "./../CustomerPhoneNumber/PhoneDisplay_V";
import BackspaceButton from "./../CustomerPhoneNumber/BackspaceButton";
import CircleButton from "./../Buttons/CircleButton_V";

import { useKioskVerticalStyles } from "./../../../../kioskverticalstyles_2";

import {
  Button,
  Grid,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  TextField,
  Typography,
  OutlinedInput,
  ButtonGroup
} from "@mui/material";

import KioskStepper from "./../../Components/Stepper/KioskStepper_V";
import Logo from "./../../Components/Logo_V";

import BiRowNumberSelect from "./../Shared/NumberOf/BiRowNumberSelect";

import formatFirstNameLastInitial from "./../../HelperFunctions/formatFirstNameLastInitial";
import formatAddress from "./../../HelperFunctions/formatAddress";

import { WORKFLOW_MODES } from "../../../../constants";

import { useTheme } from "@mui/material/styles";

import PrinterConnectionModal from "./../Shared/PrinterConnectionModal_V";

let env = require("./../../../../env");

function displayError(errorCode) {
  switch (errorCode) {
    case 400:
      return translate("application.phonenumber.errors.unablefetchaccount");
    case 401:
      return translate("application.phonenumber.errors.invalidphone");
    case 404:
      return translate("application.errors.invalidcredentials");
    case 503:
      return translate("application.errors.serverunavailable");
    default:
      return translate("application.errors.unknownerror");
  }
}

export default function VerticalLayout(props) {
  const {
    setKioskkeyFunc,
    nextFunc,
    loading,
    //errorMessage,
    isNotMobile,
    kioskkey,
    numbagpress,
    workflowmode,
    getKioskConfiguration
  } = props;

  const {
    //customerName,
    customerFirstName,
    customerLastName,
    customerID,
    charityName,
    charityID,
    setCustomerNameAndID,
    numBags,
    setNumBags,
    numLabels,
    setLabels,
    sessionID,
    setAll,
    customerReset
  } = useContext(KioskContext);

  const { getKioskTheme } = useContext(SocketIOContext);

  const { simplepost } = useContext(HttpContext);
  const theme = useTheme();
  const navigate = useNavigate();
  const kioskverticalstyles_2 = useKioskVerticalStyles();

  const [phonenumber, setPhonenumber] = useState("");
  const [showconfirmdialog, setShowconfirmdialog] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [locationAddress, setLocationAddress] = useState("");
  const [locationName, setLocationName] = useState("");

  const [workflowMode, setWorkflowMode] = useState(
    getKioskConfiguration()?.workflowMode
  );

  useEffect(() => {
    const kioskConfig = getKioskConfiguration();

    if (kioskConfig == undefined || kioskConfig == null) {
      return navigate("/errorscreen");
    }

    setLocationAddress(kioskConfig.locationAddress);
    setLocationName(kioskConfig.locationName);
  }, []);

  const onIdle = async () => {
    if (env.IDLETIMER) {
      const kiosktheme = getKioskTheme();
      if (kiosktheme.bilingual) {
        setLocale("fr");
      }

      navigate("/language");
    }
  };

  return (
    <IdleTimerProvider timeout={30000} onIdle={onIdle}>
      <div style={kioskverticalstyles_2.flexBackground}>
        <div style={kioskverticalstyles_2.logo}>
          <center>
            <Logo />
          </center>
        </div>

        <div style={kioskverticalstyles_2.instructionDiv}>
          <div style={kioskverticalstyles_2.instructionVerticallyAlignDiv}>
            <Translate
              value="application.theme.wizardWelcomeText"
              name={formatFirstNameLastInitial(
                customerFirstName,
                customerLastName
              )}
            />
            <br />
            <Translate
              value="application.theme.wizardAddressText"
              name={locationName}
              address={formatAddress(locationAddress)}
            />
          </div>
        </div>

        <div
          style={{
            ...kioskverticalstyles_2.whiteDiv,
            ...kioskverticalstyles_2.flexcenterDiv
            //justifyContent: "space-between"    //Not using to keep layout save with other NumberOf
          }}
        >
          <div
            style={{
              marginTop: "5vh",
              height: "7.7vh", //Not commenting out to keep layout save with other NumberOf
              marginBottom: "7.7vh", //Not commenting out to keep layout save with other NumberOf
              width: "83vw"
            }}
          >
            <div
              class="fontSecondaryText"
              style={{
                width: "100%",
                textAlign: "center",
                fontSize: "3.4vh"
              }}
            >
              {workflowmode == WORKFLOW_MODES.BAG_ONLY ||
              workflowmode == WORKFLOW_MODES.BAG_ONLY_WITH_AUTH ? (
                <Translate value="application.theme.NumberOfBagsBagsOnlyTitleText" />
              ) : (
                <Translate value="application.theme.NumberOfBagsMainText" />
              )}
            </div>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "2vw",
              width: "100%",
              marginBottom: "8.2vh"
              //marginBottom: "0.5vh"    //Not using to keep layout save with other NumberOf
            }}
          >
            <BiRowNumberSelect
              workflowmode={workflowMode}
              rowstyle={kioskverticalstyles_2.biRowNumberSelect}
              CircleButtonElement={CircleButton}
              numbagpressFunc={numbagpress}
            />
          </div>
          <div
            class="fontSecondaryText"
            style={{
              // ...kioskstyles.leftRightMargins,
              // ...kioskstyles.blackBodyText,
              display: "flex",
              flexDirection: "column",
              width: "83vw",
              marginLeft: "auto",
              marginRight: "auto",
              paddingLeft: "0.6vh",
              paddingRight: "0.6vh"
            }}
          >
            <div style={kioskverticalstyles_2.InfoText}>
              <div
                style={{
                  marginBottom: "2vh",
                  textAlign: "center",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center"
                }}
              >
                <span>
                  <b>
                    {workflowmode == WORKFLOW_MODES.BAG_ONLY ||
                    workflowmode == WORKFLOW_MODES.BAG_ONLY_WITH_AUTH ? (
                      <Translate
                        value="application.theme.NumberOfBagsBagsOnlyInfo1Text"
                        count="8"
                      />
                    ) : (
                      <Translate
                        value="application.theme.numberOfBagsInfo2"
                        count="7"
                      />
                    )}
                  </b>
                </span>{" "}
                <span>
                  {workflowmode == WORKFLOW_MODES.BAG_ONLY ||
                  workflowmode == WORKFLOW_MODES.BAG_ONLY_WITH_AUTH ? (
                    <Translate
                      value="application.theme.NumberOfBagsBagsOnlyDescription1Text"
                      count="8"
                    />
                  ) : (
                    <Translate
                      value="application.theme.numberOfBagsDescription2"
                      count="7"
                    />
                  )}
                </span>
              </div>
              <div
                style={{
                  //marginBottom: "3vh",    //Not using to keep layout save with other NumberOf
                  textAlign: "center",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center"
                }}
              >
                {workflowmode == WORKFLOW_MODES.BAG_ONLY ||
                workflowmode == WORKFLOW_MODES.BAG_ONLY_WITH_AUTH ? (
                  <></>
                ) : (
                  <>
                    <span>
                      <b>
                        <Translate value="application.theme.numberOfBagsInfo1" />
                      </b>
                    </span>{" "}
                    <span>
                      <Translate value="application.theme.numberOfBagsDescription1" />
                    </span>
                    <br />
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
        <div style={kioskverticalstyles_2.footerDiv}>
          <KioskStepper
            activeStep={1}
            backUrl={"/phonenumber"}
            workflowmode={workflowmode}
            getKioskConfiguration={getKioskConfiguration}
          />
        </div>
      </div>
      <IdleTimerDisplay />
      <PrinterConnectionModal />
    </IdleTimerProvider>
  );
}
